import React, { useEffect, useState } from "react";
import "./GotCovered.css";
import covered_layout from "../../assets/img/claims/covered_layout.svg";
import checkIcon from "../../assets/img/aboutus/check.svg";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";

const GotCovered = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <>
      <div className="py-5" style={styles.container}>
        <Container style={{ maxWidth: "1350px", margin: "0 auto" }}>
          <Row
            className="align-items-center"
            style={{ position: "relative", left: 0, marginLeft: "0px" }}
          >
            {/* Left Column: Text Content */}
            <Col lg={6}>
              <p
                style={{
                  color: "#17252E",
                  fontSize: "16px",
                  lineHeight: "140%",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  position: "relative", // required for ::after
                  display: "inline-block",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    paddingBottom: "5px",
                  }}
                >
                  We've Got You Covered!
                  <span
                    style={{
                      content: '""',
                      position: "absolute",
                      left: 0,
                      bottom: -4,
                      height: "1.6px",
                      width: "140%", // Extend beyond text
                      backgroundColor: "#0e72d6",
                      transform: "translateX(0%)", // Centered extension
                    }}
                  />
                </span>
              </p>

              <h2
                className="mt-2"
                style={{
                  color: "#17252E",
                  lineHeight: "1",
                  fontWeight: "bold",
                  fontSize: responsiveStatus ? "20px" : "40px",
                  marginBottom: "1em",
                }}
              >
                What should I do if I met with an accident?
              </h2>

              {responsiveStatus === "isMobile" ||
              responsiveStatus === "isSmallMobile" ? (
                <div className="uaic -image-wrapper mx-auto">
                  <Image
                    src={require("../../assets/img/claims/claims.jpg")}
                    fluid
                    className="aboutRightImage"
                    alt="claims_image"
                  />
                </div>
              ) : (
                <div className="d-flex flex-wrap gap-3">
                  <ul
                    className="gap-1"
                    style={{ listStyle: "none", padding: 0, margin: 0 }}
                  >
                    {[
                      "Determine if there are any injuries in any cars involved in accident.",
                      "Remain calm. If safe, move vehicles out of traffic and turn on your hazard lights.",
                      "Please refrain from making statements regarding fault or liability, and do not disclose your insurance coverage limits to others involved. These matters will be appropriately addresses by your insurance company as part of the claims handling proves. ",
                      "Take photos of the accident scene and all vehicles involved. This would include skid marks, lights, lanes, intersections, and any other aspects of the scene.",
                      "Report the incident to United Automobile Insurance as soon as possible. <b>You can file a claim with us online, 24/7!</b>",
                    ].map((item, i) => (
                      <li
                        key={i}
                        style={{
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={checkIcon}
                          alt="check"
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        <span
                          className="aboutTextStyle"
                          dangerouslySetInnerHTML={{ __html: item }}
                        ></span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </Col>

            <Col lg={6} className="position-relative mt-5 mt-lg-0 ">
              {responsiveStatus === "isMobile" ||
              responsiveStatus === "isSmallMobile" ? (
                <div className="d-flex flex-wrap gap-3">
                  <ul
                    className="gap-1"
                    style={{ listStyle: "none", padding: 0, margin: 0 }}
                  >
                    {[
                      "Determine if there are any injuries in any cars involved in accident.",
                      "Remain calm. If safe, move vehicles out of traffic and turn on your hazard lights.",
                      "Please refrain from making statements regarding fault or liability, and do not disclose your insurance coverage limits to others involved. These matters will be appropriately addresses by your insurance company as part of the claims handling proves. ",
                      "Take photos of the accident scene and all vehicles involved. This would include skid marks, lights, lanes, intersections, and any other aspects of the scene.",
                      "Report the incident to United Automobile Insurance as soon as possible. <b>You can file a claim with us online, 24/7!</b>",
                    ].map((item, i) => (
                      <li
                        key={i}
                        style={{
                          marginBottom: "12px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={checkIcon}
                          alt="check"
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        <span
                          className="aboutTextStyle"
                          dangerouslySetInnerHTML={{ __html: item }}
                        ></span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="uaic -image-wrapper mx-auto">
                  <Image
                    src={require("../../assets/img/claims/claims.jpg")}
                    fluid
                    // className="aboutRightImage-t"
                    style={{
                      borderRadius: "11px",
                      marginLeft: "15%",
                      boxShadow: "15px 20px 15px 4px rgb(229 247 250)",
                    }}
                    className={
                      responsiveStatus === "isDesktop"
                        ? "aboutRightImage"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "aboutRightImage-t"
                        : "aboutRightImage"
                    }
                    alt="claims_image"
                  />
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${covered_layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default GotCovered;
